import Video from '../Video';

import './style.css';

const Galeria = () => {
  return(
    <section id="galeria">
      <div className="grid">
        <Video url="https://www.youtube.com/embed/XcU9GEUZTQA" title="Iniciando com React Native" />
      
        <Video url="https://www.youtube.com/embed/mqltv3kFdgE" title="React Native // Dicionário do Programador" />

        <Video url="https://www.youtube.com/embed/9F6KARtsH_E" title="React vs React Native - Qual a diferença?" />
      </div>
    </section>
  )
}

export default Galeria;